/**
 * Blogs Guci 
 * Date: 2024/07/04
 * filename：en.js
 */


export const en = {
    system: "Background management system",
    full: "full-screen display",
    account: "myAccount",
    invoice: "invoice",
    reconciliation: "Statement",
    record: "recording",
    report: "report",
    setting: "Settings",
    login: "login",
    tips: "Username and password are filled in casually",
    administrator: "administrator",
    placeUser: "please enter user name",
    palcePass: "Please enter your password",
    palceCode: "please enter verification code",
    accounts: "accounts",
    password: "password",
    code: "Verification code"
}


 
export default en;


// WEBPACK FOOTER //
// ./src/i18n/en.js